import React from 'react';

import {Button, Icon, Menu, Text} from '@albert-io/atomic';
import {CREATED_BY_FILTER_OPTIONS} from 'client/TeacherDashboard/config/filterOptions';
import type {ClassworkCreatedByFilter} from 'client/TeacherDashboard/types';

interface Props {
  createdBy: ClassworkCreatedByFilter;
  disabled?: boolean;
  onChange: (value: ClassworkCreatedByFilter) => void;
}

export const FiltersMenu = ({createdBy, disabled, onChange}: Props) => {
  const isActive = createdBy !== 'all';
  return (
    <Menu closeOnItemClick position='bottom-end' positionFixed>
      <Menu.Trigger>
        {(triggerProps) => (
          <Button
            {...triggerProps}
            color='secondary'
            disabled={disabled}
            variant='outlined'
            data-testid='filters-trigger'
          >
            <Icon className='mr-x1' color={isActive ? 'brand' : undefined} icon='bars-filter' />
            <Text color={isActive ? 'brand' : 'inherit'}>Filters</Text>
            {isActive && (
              <span aria-hidden className='ml-x1 h-x1 w-x1 rounded-full background-brand' />
            )}
          </Button>
        )}
      </Menu.Trigger>
      <Menu.Content>
        <Menu.Item readonly textProps={{color: 'secondary', size: 's'}}>
          Created by
        </Menu.Item>
        {CREATED_BY_FILTER_OPTIONS.map((option, index) => (
          <React.Fragment key={option.value}>
            {index === 1 && <Menu.Divider />}
            <Menu.Item
              selected={createdBy === option.value}
              rightIconProps={createdBy === option.value ? {icon: 'check'} : undefined}
              onClick={() => onChange(option.value)}
            >
              {option.label}
            </Menu.Item>
          </React.Fragment>
        ))}
      </Menu.Content>
    </Menu>
  );
};
